<div>
  <div *ngIf="dadosEntregas.entregas.length">
    <div class="mt-2 mb-2">
      <div class="d-flex">
        <img src="assets/img/icons/icon-box-pedido.svg" alt="" class="me-2"> <span class="titulo">Pedidos ({{
          dadosEntregas.entregas.length }})</span>
        <div class="container-ped-situacao">
          <div *ngIf="contadorPedEntregues>0" class="ped-entregue">
            <img class="icon-sinalizacao-pedido" src="assets/img/icons/icon-circle-pedido-finalizado.svg" alt="">
            {{ contadorPedEntregues }}
          </div>
          <div *ngIf="contadorPedRecusados>0" class="ped-recusado">
            <img class="icon-sinalizacao-pedido" src="assets/img/icons/icon-circle-pedido-recusado.svg" alt="">
            {{ contadorPedRecusados }}
          </div>
          <div *ngIf="contadorPedPendentes>0" class="ped-pendentes">
            <img class="icon-sinalizacao-pedido" src="assets/img/icons/icon-circle-pedido-pendente.svg" alt="">
            {{ contadorPedPendentes }}
          </div>
          <div>
          </div>
        </div>
      </div>
      <div *ngIf="item.IdRoteiroPedidoSituacao > 5 && item.IdRoteiroPedidoSituacao < 8"
        class="position-relative container-tempo-entrega">
        <div class="content-tempo-entrega">
          <img *ngIf="item.dataInicioEntrega == null || item.dataFinalEntrega == null"
            src="assets/img/icons/icon-exclamation-circle-orange.svg" alt="" placement="top"
            ngbTooltip="As ações de início e fim da entrega não foram acompanhadas do sinal de GPS impossibilitando nossos cálculos de tempo. Verifique com o motorista se o funcionamento do GPS esta ativado.">
          <span class="text-tempo-entrega">
            início entrega
            <strong class="time-tempo-entrega">
              {{ item.dataInicioEntrega ? (item.dataInicioEntrega | date: 'HH:mm') : '--:--' }}
            </strong>
          </span>
          <div class="separator"></div>
          <span class="text-tempo-entrega">
            Fim entrega
            <strong class="time-tempo-entrega">
              {{ item.dataFinalEntrega ? (item.dataFinalEntrega | date: 'HH:mm') : '--:--' }}
            </strong>
          </span>
          <div class="separator hide-on-mobile"></div>
          <span class="text-tempo-entrega hide-on-mobile">
            Duração
            <strong class="time-tempo-entrega">
              {{ (item.dataInicioEntrega == null || item.dataFinalEntrega == null) ? '--:--' : (item.tempoEntrega) }}
            </strong>
          </span>
        </div>
      </div>

      <div id="box-pedidos" class="grid-pedidos">
        <div class="info-pedidos" (click)="AbrirTabelaPedidos($event)">
          <div class="titulo d-flex align-items-start" title="Valor"> <img src="assets/img/icon_header_pedidos.svg">
            <p class="pp-valor mb-0">R$ {{ dadosEntregas.valorTotalPedido | number:'1.2-2' }}</p>
          </div>
          <div class="titulo d-flex align-items-start" title="Peso"> <img src="assets/img/icon_header_peso.svg">
            <p class="pp-valor mb-0">{{ dadosEntregas.pesoTotalPedido | number:'1.2-2' }} Kg</p>
          </div>
          <div class="titulo d-flex align-items-start" title="Volume"> <img src="assets/img/icon_header_volume.svg">
            <p class="pp-valor mb-0 ">{{ dadosEntregas.QtdeVolumes }} </p>
          </div>
          <div class="titulo d-flex align-items-start" *ngIf="dadosEntregas.custoDescarga>0" title="Custo Descarga">
            <img src="assets/img/icon_header_custo_descarga.svg">
            <p class="pp-valor mb-0">R$ {{ dadosEntregas.custoDescarga | number:'1.2-2' }} </p>
          </div>
          <i class="fa fa-chevron-down"></i>
        </div>
        <table class="pedidos-detalhes">
          <thead class="bd-thead">
            <tr>
              <th class="vertical-center"> Pedido </th>
              <th class="vertical-center hide-on-mobile"> Data </th>
              <th class="vertical-center"> NF </th>
              <th class="vertical-center hide-on-mobile"> Vendedor</th>
              <th class="vertical-center"> Valor (R$) </th>
              <th class="vertical-center hide-on-mobile"> Pag. Efetuado </th>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let itemPedido of dadosEntregas.entregas" (click)="atualizaDetalhesPedido(itemPedido)"
              [class.hoverable]="item.ResumoNFeJSON">
              <ng-container>

                <td>
                  <div>
                    <img placement="top" ngbTooltip="Entrega realizada" style="margin-bottom: 3px;"
                      *ngIf="itemPedido.IdRoteiroPedidoSituacao == 6 || itemPedido.EntregaRealizada == 1"
                      src="assets/img/icons/icon-circle-pedido-finalizado.svg" alt="">
                    <img placement="top" ngbTooltip="Entrega recusada" style="margin-bottom: 3px;"
                      *ngIf="itemPedido.IdRoteiroPedidoSituacao == 5 || itemPedido.EntregaRealizada == 0"
                      src="assets/img/icons/icon-circle-pedido-recusado.svg" alt="">
                    <img placement="top" ngbTooltip="Entrega pendente" style="margin-bottom: 3px;"
                      *ngIf="itemPedido.IdRoteiroPedidoSituacao == 7 || itemPedido.IdRoteiroPedidoSituacao == 4 || itemPedido.IdRoteiroPedidoSituacao == 1"
                      src="assets/img/icons/icon-circle-pedido-pendente.svg" alt="">
                    {{ itemPedido.NumeroPedido ? itemPedido.NumeroPedido : '-' }}
                  </div>
                </td>
                <td class="hide-on-mobile">
                  <div class="d-flex"></div>
                  {{ itemPedido.DataPedido ? (itemPedido.DataPedido | date:'dd/MM') : '-' }}
                </td>
                <td>{{ itemPedido.Nf ? itemPedido.Nf : '-' }}</td>
                <td>{{ itemPedido.CodigoVendedor ? itemPedido.CodigoVendedor : '-' }}</td>
                <td>{{ itemPedido.ValorPedido ? (itemPedido.ValorPedido | currency :'BRL') : '-' }}</td>
                <td class="hide-on-mobile">{{ itemPedido.FormaPagamentoEfetuada ? itemPedido.FormaPagamentoEfetuada :
                  '-' }}</td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <app-popup-detalhes-pedido *ngIf="detalhesPedidosServices.mostrarPopDetalhesPedido"></app-popup-detalhes-pedido>

  <div *ngIf="dadosColetas.coletas.length">
    <div class="mt-2 mb-2">
      <div>
        <div class="d-flex">
          <img src="assets/img/icons/icon-box-coleta.svg" alt="" class="me-2"> <span class="titulo">Coletas ({{
            dadosColetas.coletas.length }})</span>
          <div class="container-ped-situacao">
            <div *ngIf="contadorColEntregues>0" class="ped-entregue">
              <img class="mb-1" src="assets/img/icons/icon-circle-pedido-finalizado.svg" alt="">
              {{ contadorColEntregues }}
            </div>
            <div *ngIf="contadorColRecusados>0" class="ped-recusado">
              <img class="mb-1" src="assets/img/icons/icon-circle-pedido-recusado.svg" alt="">
              {{ contadorColRecusados }}
            </div>
            <div *ngIf="contadorColPendentes>0" class="ped-pendentes">
              <img class="mb-1" src="assets/img/icons/icon-circle-pedido-pendente.svg" alt="">
              {{ contadorColPendentes }}
            </div>
            <div>
            </div>
          </div>
        </div>

        <div id="box-pedidos" class="grid-pedidos">
          <div class="info-pedidos" (click)="AbrirTabelaPedidos($event)">
            <div class="titulo d-flex align-items-start" title="Valor"> <img src="assets/img/icon_header_pedidos.svg">
              <p class="pp-valor mb-0">R$ {{ dadosColetas.valorTotalPedido | number:'1.2-2' }}</p>
            </div>
            <div class="titulo d-flex align-items-start" title="Peso"> <img src="assets/img/icon_header_peso.svg">
              <p class="pp-valor mb-0">{{ dadosColetas.pesoTotalPedido | number:'1.2-2' }} Kg</p>
            </div>
            <div class="titulo d-flex align-items-start" title="Volume"> <img src="assets/img/icon_header_volume.svg">
              <p class="pp-valor mb-0 ">{{ dadosColetas.QtdeVolumes }} </p>
            </div>
            <i class="fa fa-chevron-down"></i>
          </div>
          <table class="pedidos-detalhes">
            <thead class="bd-thead">
              <tr>
                <th class="vertical-center"> Pedido </th>
                <th class="vertical-center hide-on-mobile"> Data </th>
                <th class="vertical-center"> NF </th>
                <th class="vertical-center"> Valor (R$)</th>
                <th class="vertical-center"> Peso (Kg) </th>
                <th class="vertical-center"> Vol. </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let itemColeta of dadosColetas.coletas" (click)="atualizaDetalhesPedido(itemColeta)"
                [class.hoverable]="item.ResumoNFeJSON">
                <td>
                  <div>
                    <img placement="top" ngbTooltip="Coletado" style="margin-bottom: 3px;"
                      *ngIf="itemColeta.IdRoteiroPedidoSituacao == 6 || itemColeta.EntregaRealizada == 1"
                      src="assets/img/icons/icon-circle-pedido-finalizado.svg" alt="">
                    <img placement="top" ngbTooltip="Recusado" style="margin-bottom: 3px;"
                      *ngIf="itemColeta.IdRoteiroPedidoSituacao == 5 || itemColeta.EntregaRealizada == 0"
                      src="assets/img/icons/icon-circle-pedido-recusado.svg" alt="">
                    <img placement="top" ngbTooltip="Entrega pendente" style="margin-bottom: 3px;"
                      *ngIf="itemColeta.IdRoteiroPedidoSituacao == 7 || itemColeta.IdRoteiroPedidoSituacao == 4 || itemColeta.IdRoteiroPedidoSituacao == 1"
                      src="assets/img/icons/icon-circle-pedido-pendente.svg" alt="">
                    {{ itemColeta.NumeroPedido > 0 ? itemColeta.NumeroPedido : '-' }}
                  </div>
                </td>
                <td class="hide-on-mobile">{{ itemColeta.DataPedido ? (itemColeta.DataPedido | date:'dd/MM') : '-' }}
                </td>
                <td>{{ itemColeta.Nf ? itemColeta.Nf : '-' }}</td>
                <td>{{ itemColeta.ValorPedido ? (itemColeta.ValorPedido | currency :'BRL') : '-' }}</td>
                <td>{{ itemColeta.Peso ? itemColeta.Peso : '-' }}</td>
                <td>{{ itemColeta.QtdeVolumes ? itemColeta.QtdeVolumes : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
